/**
 * Better-auth client for dashboard
 * Provides magic link authentication and session management
 */

import { createAuthClient } from 'better-auth/react';
import { magicLinkClient } from 'better-auth/client/plugins';

// Get API URL from environment variable
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export const authClient = createAuthClient({
  baseURL: API_URL,
  // Enable cross-domain cookies for staging (pages.dev <-> workers.dev)
  fetchOptions: {
    credentials: 'include',
  },
  plugins: [magicLinkClient()],
});

// Export commonly used auth methods for convenience
export const {
  signOut,
  useSession,
} = authClient;

// Export magic link method
// Use sendMagicLink which sends to /api/auth/sign-in/magic-link
export const signInMagicLink = authClient.signIn.magicLink;
